<template>
  <div
    :class="{
      'no-margin-top': liquid.settings.disable_inner_padding_top
    }"
    class="shop-the-look-full-banner critical-component-clear container"
  >
    <div
      v-if="liquid.settings.eyebrow || liquid.settings.highlighter_copy"
      class="shop-the-look-full-banner__title"
    >
      <eyebrow
        v-if="liquid.settings.eyebrow"
        :enable-bullet="liquid.settings.eyebrow_bullet"
        :text="liquid.settings.eyebrow"
      />
      <highlighter-title
        v-if="liquid.settings.highlighter_copy"
        :highlighter-color="liquid.settings.highlighter_color"
        :highlighter-copy="liquid.settings.highlighter_copy"
        custom-element="h1"
      />
    </div>

    <shop-the-look
      :desktop-image="liquid.desktopImage"
      :layout="liquid.settings.layout_preference"
      :mobile-image="liquid.mobileImage"
      :section-id="liquid.sectionId"
      :shop-tag-blocks="liquid.blocks"
      block-class="shop-the-look-full-banner"
    >
      <template #shoppay>
        <slot name="shoppay" />
      </template>
    </shop-the-look>
  </div>
</template>

<script>

/**
 * Vue: Shop the look full banner (shop-the-look-full-banner)
 * -----------------------------------------------------------------------------
 * Shop tag functionality on a single full width banner with a highlightable
 * title.
 *
 * @param {Array} liquid.blocks - The section blocks.
 * @param {Object} desktopImage - Image object with alt text, src, width, and
 * height.
 * @param {Object} mobileImage - Image object with alt text, src, width, and
 * height.
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {Array} liquid.settings - All of the section's settings.
 *
 */

import ShopTheLook from '~async/shop-the-look/shop-the-look'

export default {
  name: 'ShopTheLookFullBanner',

  components: {
    ShopTheLook,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        blocks: [],
        desktopImage: {},
        mobileImage: {},
        sectionId: '',
        settings: {},
      }),
    },
  },
}
</script>

<style lang="scss">
@import './shop-the-look-full-banner';
</style>
